import { createSlice } from '@reduxjs/toolkit';
import { fetchAreaList } from './thunk';

export type AreaType = {
    _id: string
    area: string
    state: string | null
    city: string | null
    isActive: boolean
}

export type paginationType = {
    totalCount: number,
    page: number
    pageSize: number
}

export type FilterType = {
    isActive: boolean | null
    state: string,
    city: string,
    search: string;
    sortBy: any,
    sortOrder: any,
    totalCount: number,
    page: number,
    limit: number
}

interface AreaState {
    areaList: AreaType[];
    filterData: FilterType,
    paginationData: paginationType
    loading: {
        areaList: boolean
    }
}



const initialState: AreaState = {
    loading: {
        areaList: false
    },
    filterData: {
        isActive: null,
        state: "",
        city: "",
        search: "",
        sortBy: "",
        sortOrder: null,
        totalCount: 0,
        page: 1,
        limit: 50,
    },
    paginationData: {
        totalCount: 0,
        page: 1,
        pageSize: 50
    },
    areaList: [],
};

const AreaSlice = createSlice({
    name: 'area',
    initialState,
    reducers: {
        setAreaList(state, action) {
            state.areaList = action.payload
        },
        setFilterData(state, action) {
            state.filterData = action.payload
        },

    },
     extraReducers: (builder) => {
            builder
                .addCase(fetchAreaList.pending, (state) => {
                    state.loading.areaList = true;
                })
                .addCase(fetchAreaList.fulfilled, (state, action) => {                 
                    state.loading.areaList = false;
                    state.areaList = action.payload.data as any;
                    state.filterData = {
                      ...state.filterData,
                      ...action.payload.filterData,
                    };
                  })
                .addCase(fetchAreaList.rejected, (state, action) => {
                    state.loading.areaList = false;
                });
        },
});

export const { setAreaList, setFilterData } = AreaSlice.actions;

export default AreaSlice.reducer;
